import React from 'react'

const Menu = ({ items }) => {
  return (
    <div className="section-center ">
      {items.map((menuItem) => {
        const { id, title, img,  desc } = menuItem
        return (
          <article key={id} className="menu-item">
            <img src={img} alt={title} className="photo" />
            <div className="item-info">
              <header>
                <h4 style={{fontWeight:"bold"}}>{title}</h4>
                {/* <h4 className="price">N{price}</h4> */}
              </header>
              <p className="item-text">{desc}</p>
            </div>
          </article>
        )
      })}
    </div>
  )
}

export default Menu
